import { Component, OnInit } from '@angular/core';
import { IssueTrackerService } from 'src/app/services/issueTracker.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-issue-tracker-dialog',
  templateUrl: './issue-tracker-dialog.component.html',
  styleUrls: ['./issue-tracker-dialog.component.css']
})
export class IssueTrackerDialogComponent implements OnInit {
  issues = [];
  loading = false;
  submitting = false;
  message = '';

  issue = {
    reporter: '',
    title: '',
    description: '',
    priority: 'normal'
  };

  displayedColumns = ['date', 'header', 'status', 'priority', 'reporter'];

  constructor(
    private issueTrackerService: IssueTrackerService,
    private userService: UserService
  ) {}

  async ngOnInit() {
    const currentUser: any = await this.userService.getCurrentUser().toPromise();

    this.issue.reporter = currentUser && currentUser.email
      ? currentUser.email
      : currentUser && currentUser.username
        ? currentUser.username
        : '';

    this.loadIssues();
  }

  async loadIssues() {
    this.loading = true;

    try {
      const result: any = await this.issueTrackerService.getIssues().toPromise();
      this.issues = Array.isArray(result) ? result : (result.issues || result.data || []);
    } catch (err) {
      console.error('Issue list load failed:', err);
      this.issues = [];
    }

    this.loading = false;
  }

  async submitIssue() {
    if (!this.issue.reporter || !this.issue.title || !this.issue.description) {
      this.message = 'ISSUE_TRACKER.REQUIRED_FIELDS';
      return;
    }

    this.submitting = true;
    this.message = '';

    try {
      const result: any = await this.issueTrackerService.submitIssue(this.issue).toPromise();

      if (result && result.success) {
        this.message = 'ISSUE_TRACKER.SUBMITTED';
        this.issue.title = '';
        this.issue.description = '';
        this.issue.priority = 'normal';
        await this.loadIssues();
      } else {
        this.message = result && result.error ? result.error : 'ISSUE_TRACKER.SUBMIT_FAILED';
      }
    } catch (err) {
      console.error('Issue submit failed:', err);
      this.message = 'ISSUE_TRACKER.NETWORK_ERROR';
    }

    this.submitting = false;
  }
}